function initSimpleToggle() {
	var toggle = $('.toggle-next-block');
	
	toggle.each(function(index, elem) {
		$(elem).on('click', function () {
			$(elem).next().toggleClass('hidden');
		});
	});
}